/**
 * SessionCombinedChart.jsx : Vue combinée de la page de session, avec le
 * bandeau d'orientation mobile qui la précède.
 *
 * Sortie de SessionCharts en 10.5.313 (D239) pour être rendue juste sous la
 * barre de période, avant les cartes. Toujours montée : l'export PDF capture
 * #combined-chart-container dans le DOM (pdfCharts.js).
 */
import React from 'react';
import { useTranslation } from 'react-i18next';
import { BRAND } from '../constants/theme';
import CombinedChart from '../charts/CombinedChart';

// windowKey : identité de la période affichée (remonte le graphique, zoom remis à zéro).
const SessionCombinedChart = ({ readings, darkMode, onQuickAnnotate, onAnalyzeZoom, windowKey = 'session' }) => {
  const { t } = useTranslation();

  return (
    <>
      {/* Bannière orientation mobile — CSS pure, 0 JS */}
      <style>{`
        @media (max-width: 600px) and (orientation: portrait) {
          .eky-landscape-hint { display: flex !important; }
        }
      `}</style>
      <div className="eky-landscape-hint" style={{
        display: 'none', alignItems: 'center', gap: '10px',
        padding: '10px 14px', borderRadius: '8px', marginBottom: '12px',
        background: 'rgba(27,119,241,0.08)', border: '1px solid rgba(27,119,241,0.2)',
        fontSize: '12px', color: BRAND.blueText
      }}>
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <rect x="4" y="8" width="16" height="12" rx="2"/><path d="M8 8V6a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/>
        </svg>
        <span>{t('charts.landscapeHint')}</span>
      </div>

      <div id="combined-chart-container" role="region" aria-label={t('charts.aria.combined')}>
        <CombinedChart key={windowKey} readings={readings} darkMode={darkMode} onQuickAnnotate={onQuickAnnotate}
          onAnalyzeZoom={onAnalyzeZoom} />
      </div>
    </>
  );
};

export default SessionCombinedChart;
